import showToast from '../components/ToastComponent';
import { fetchAllPostmarkEmailTemplates } from '../service/fetchAllEmailTemplatesInPostmark';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FiltersState, TemplateSelectOptionItem } from '../interface/interface';
import { SingleValue } from 'react-select';
import { validatePostMarkTemplate } from '../service/fetchEmailTemplateByAlias';

const useTemplateList = (
  accessToken: string | undefined,
  isValid: (isValid: boolean) => void,
  filters: FiltersState,
  setFilters: Dispatch<SetStateAction<FiltersState | undefined>>,
): [
  boolean | undefined,
  Array<TemplateSelectOptionItem>,
  (selected: SingleValue<TemplateSelectOptionItem>) => Promise<void>,
] => {
  const [loading, setLoading] = useState<boolean>(false);

  const [templateList, setTemplateList] = useState<
    Array<TemplateSelectOptionItem>
  >([]);

  useEffect(() => {
    if (!accessToken) return;
    setLoading(true);
    fetchAllPostmarkEmailTemplates(accessToken!).then((res) => {
      if (typeof res === 'number') {
        showToast({
          type: 'warning',
          message: 'Unable to fetch templates',
        });
        setLoading(false);
        return;
      }

      setTemplateList(
        res.map((e) => ({ label: e.templateName, value: e.templateAlias })),
      );
      setLoading(false);
    });
  }, [accessToken]);

  const handleSelection = async (
    selected: SingleValue<TemplateSelectOptionItem>,
  ) => {
    if (!selected) return;

    setFilters({
      ...filters,
      template: selected!,
    });
    setLoading(true);
    const templateData = await validatePostMarkTemplate(
      accessToken!,
      selected.value,
      filters?.userType?.value,
    );

    if (typeof templateData === 'number') {
      showToast({
        type: 'warning',
        message: 'Invalid template. Please select another template',
      });
      isValid(false);
      setLoading(false);
      return;
    }
    isValid(true);
    setLoading(false);
  };

  return [loading, templateList, handleSelection];
};

export default useTemplateList;
